import React from "react";
import SearchCategories from "./SearchCategories";
import SearchFilterBtn from "./SearchFilterBtn";
import SearchHeader from "./SearchHeader";
import SortedData from "../data/data.json";
import FoodCard from "./common/FoodCard";

const LowToHigh = () => {
  return (
    <div>
      <SearchHeader />
      <SearchFilterBtn />
      <SearchCategories />
      <FoodCard data={SortedData.sort((a, b) => a.itemPrice - b.itemPrice)} />
    </div>
  );
};

export default LowToHigh;
